module.exports = __webpack_public_path__ + "static/media/routes-no-background.d791b7cf.svg";